(() => {
  const selector = '[data-h2o-product-carousel]';

  const prepareQuickAdd = (root) => {
    root.querySelectorAll('[data-h2o-product-card]').forEach((card) => {
      const cardWrapper = card.querySelector(':scope > .card-wrapper');
      const information = cardWrapper?.querySelector(':scope > .card-information');
      const overlay = cardWrapper?.querySelector(':scope > .card-wrapper__link--overlay');
      const action = cardWrapper?.querySelector('.card__add-to-cart, .quick-add');

      if (cardWrapper && information && action && action.parentElement !== cardWrapper) {
        cardWrapper.insertBefore(action, overlay || null);
      }

      if (card.dataset.productAvailable === 'false') return;

      const title = card.dataset.productTitle || 'product';
      card.querySelectorAll('.card__link').forEach((button) => {
        button.removeAttribute('aria-labelledby');
        button.setAttribute('aria-label', `Quick Add — ${title}`);
      });
    });
  };

  const initialise = (root) => {
    if (!root || root.dataset.h2oProductCarouselInitialised === 'true') return;

    const track = root.querySelector('[data-h2o-carousel-track]');
    const previous = root.querySelector('[data-h2o-carousel-prev]');
    const next = root.querySelector('[data-h2o-carousel-next]');
    const status = root.querySelector('[data-h2o-carousel-status]');
    const items = Array.from(root.querySelectorAll('[data-h2o-carousel-item]'));

    prepareQuickAdd(root);
    if (!track || items.length === 0) return;

    root.dataset.h2oProductCarouselInitialised = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const itemLabel = root.dataset.h2oCarouselItemLabel || 'product';
    let frame = null;

    const gap = () => {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0) || 0;
    };

    const step = () => items[0].getBoundingClientRect().width + gap();

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const atStart = track.scrollLeft <= 3;
      const atEnd = track.scrollLeft >= maxScroll - 3;

      if (previous) previous.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (status) {
        const itemStep = Math.max(step(), 1);
        const firstVisible = Math.min(items.length, Math.max(1, Math.round(track.scrollLeft / itemStep) + 1));
        status.textContent = `Showing ${itemLabel} ${firstVisible} of ${items.length}.`;
      }
    };

    const requestUpdate = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateControls);
    };

    const scrollByItem = (direction) => {
      track.scrollBy({
        left: direction * step(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => scrollByItem(-1));
    next?.addEventListener('click', () => scrollByItem(1));
    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    updateControls();
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  };

  if (window.H2OProductCarousel) {
    window.H2OProductCarousel.initialiseAll();
    return;
  }

  window.H2OProductCarousel = { initialiseAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
